import { createListLoadingReducer } from './utils';

export default createListLoadingReducer('ADMINISTRATOR_ROLES');
